import type { IWorkingHours } from '@interfaces/IWorkingHours';
import { authedFetch, UnauthorizedError } from '@apis/auth';

export async function fetchWorkingHours(
  siteId: string,
  signal?: AbortSignal,
): Promise<IWorkingHours> {
  const res = await authedFetch(`/api/sites/${siteId}/working-hours`, { signal });
  if (res.ok) return (await res.json()) as IWorkingHours;

  const body = await res.json().catch(() => null);
  if (res.status === 401) throw new UnauthorizedError();
  throw new Error(body?.error?.message ?? 'Working hours are currently unavailable');
}
